import Keycloak from 'keycloak-js';

import { env } from './environment';

let realm = env;

export const initOptions = {
	url: 'https://sso.trakngo.com.au',
	realm: realm,
	clientId: 'tng-api',
	onLoad: 'login-required',
	flow: 'implicit',
}

export const keycloak = new Keycloak(initOptions);